import { withNestedView } from '@/router/routerHelpers';
import { FEATURES } from '@/access/features';
const loadView = withNestedView('files');

const filesRoutes = [
  {
    path: '/files',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '/',
        name: 'files',
        meta: { showNav: true, feature: FEATURES.FILES },
        props: true,
        component: loadView('Files'),
      },
      {
        path: 'folders/:folderId',
        name: 'files-folder',
        meta: { showNav: true, feature: FEATURES.FILES },
        props: true,
        component: loadView('Files'),
      },
    ],
  },
];

export default filesRoutes;
